import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IVehicleConfiguration } from 'next-common';

interface VehicleConfigurationState {
  vehicleConfiguration: IVehicleConfiguration;
  currentVehicleConfig: any;
  vehicleList: IVehicleConfiguration[];
}

const initialState: VehicleConfigurationState = {
  vehicleConfiguration: null,
  currentVehicleConfig: null,
  vehicleList: [],
};

const vehicleConfigurationSlice = createSlice({
  name: 'vehicleConfiguration',
  initialState,
  reducers: {
    setVehicleConfiguration: (state, action: PayloadAction<IVehicleConfiguration>) => {
      state.vehicleConfiguration = action.payload;
    },
    setCurrentVehicleConfig: (state, action: PayloadAction<any>) => {
      state.currentVehicleConfig = action.payload;
    },
    setVehicleList: (state, action: PayloadAction<IVehicleConfiguration[]>) => {
      state.vehicleList = action.payload;
    },
  },
});

export const { setVehicleConfiguration, setCurrentVehicleConfig, setVehicleList } = vehicleConfigurationSlice.actions;
export default vehicleConfigurationSlice.reducer;
